import {
    SearchableLocationFormType,
    SearchablePolygonPointFormType,
    SearchPersonFormType,
    SearchVehicleFormType,
} from '@mark43/cad-api';
import { DUMMY_VALUE_TO_CLEAR_RADIO_GROUP } from './constants';

export const defaultSubPremiseDto = {
    subPremiseValue: '',
    subPremiseName: '',
};

export const locationFormDefaultValues: SearchableLocationFormType = {
    city: '',
    country: null,
    intersectionStreet1: '',
    intersectionStreet2: '',
    state: null,
    streetAddress: '',
    zip: '',
    // @ts-expect-error need to use '' for NumberInput
    latitude: '',
    // @ts-expect-error need to use '' for NumberInput
    longitude: '',
    subPremise: '',
    subdivisions: [],
    // @ts-expect-error need to use '' for NumberInput
    radiusInFeet: '',
    subPremiseDtos: [defaultSubPremiseDto],
};

export const personFormDefaultValues: SearchPersonFormType = {
    // @ts-expect-error need to use '' for NumberInput
    ageMax: '',
    // @ts-expect-error need to use '' for NumberInput
    ageMin: '',
    dateOfBirth: null,
    driversLicenseNumber: '',
    socialSecurityNumber: '',
    driversLicenseState: null,
    firstName: '',
    eyeColor: null,
    hairColor: null,
    height: '',
    heightMax: '',
    heightMin: '',
    involvementType: null,
    involvementTypeOther: '',
    lastName: '',
    middleName: '',
    notes: '',
    phoneNumber: '',
    phoneExtension: '',
    race: null,
    sex: null,
    // @ts-expect-error need to use '' for NumberInput
    weight: '',
    // @ts-expect-error need to use '' for NumberInput
    weightMax: '',
    // @ts-expect-error need to use '' for NumberInput
    weightMin: '',
};

export const vehicleFormDefaultValues: SearchVehicleFormType = {
    color: null,
    involvementType: null,
    involvementTypeOther: '',
    notes: '',
    plateNumber: '',
    state: null,
    towType: DUMMY_VALUE_TO_CLEAR_RADIO_GROUP,
    vehicleMake: null,
    vehicleMakeOther: '',
    vehicleModel: null,
    vehicleModelOther: '',
    vinNumber: '',
    // @ts-expect-error need to use '' for NumberInput
    year: '',
};

export const vehicleFormDefaultValuesWithoutDummyValues: SearchVehicleFormType = {
    ...vehicleFormDefaultValues,
    towType: null,
};

export const polygonPointsDefaultValues: SearchablePolygonPointFormType = {
    // @ts-expect-error need to use '' for NumberInput
    latitude: '',
    // @ts-expect-error need to use '' for NumberInput
    longitude: '',
};
